

    /**
     * Returns a function that gets a property of the passed object
     */
    function prop(name){
        return function(obj){
            return obj[name];
        };
    }

    module.exports = prop;





//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/function/prop.js
// module id = u66i
// module chunks = 0 130 131 132